import { ListViewBody, ListViewLabel } from '@/components/ListView';
import { ListAmount } from '@/features/invoice_reports/components/InvoiceReportDetailDrawer/components/ListAmount';
import { SectionHeading } from '@/features/invoice_reports/components/InvoiceReportDetailDrawer/components/SectionHeading';
import { TaxAnalyze } from '@/features/invoice_reports/components/InvoiceReportDetailDrawer/components/TaxAnalyze';
import { useTranslation } from '@/i18n';
import { Bottom, ListView, Top } from '@moneyforward/ap-frontend-components';
import { GetInvoiceReportSummaryResponse } from 'ap-openapi';
import classNames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

type BasicInfoSectionProps = {
  data: GetInvoiceReportSummaryResponse;
};

export const BasicInfoSection: FC<BasicInfoSectionProps> = memo(({ data }) => {
  const { t } = useTranslation();

  return (
    <SectionHeading title={t('approving_invoice_report_detail_basic_info')}>
      <div className={cx('listViewContainer')}>
        <ListView>
          <Top>
            <ListViewLabel key='left'>
              {t('approving_invoice_report_detail_applicant')}
            </ListViewLabel>
            <ListViewBody key='right' className={cx('listViewBody')}>
              {data?.office_member?.display_name}
            </ListViewBody>
          </Top>
          {data?.report_dept && (
            <Top>
              <ListViewLabel key='left'>
                {t('approving_invoice_report_detail_department')}
              </ListViewLabel>
              <ListViewBody className={cx('listViewBody')} key='right'>
                {data?.report_dept?.name}
              </ListViewBody>
            </Top>
          )}
          {data?.agent_applicant_office_member_name && (
            <Top>
              <ListViewLabel key='left'>
                {t('approving_invoice_report_detail_agent_applicant')}
              </ListViewLabel>
              <ListViewBody key='right' className={cx('listViewBody')}>
                {data?.agent_applicant_office_member_name}
              </ListViewBody>
            </Top>
          )}
          <Top>
            <ListViewLabel key='left'>
              {t('approving_invoice_report_detail_application_status')}
            </ListViewLabel>
            <ListViewBody key='right' className={cx('listViewBody')}>
              {data?.status}
            </ListViewBody>
          </Top>
          <Top>
            <ListViewLabel key='left'>
              {t('approving_invoice_report_detail_created_at')}
            </ListViewLabel>
            <ListViewBody key='right' className={cx('listViewBody')}>
              {data?.created_at}
            </ListViewBody>
          </Top>
          <Top>
            <ListViewLabel key='left'>
              {t('approving_invoice_report_detail_application_date')}
            </ListViewLabel>
            <ListViewBody key='right' className={cx('listViewBody')}>
              {data?.submitted_at}
            </ListViewBody>
          </Top>
          <Top>
            <ListViewLabel key='left'>
              {t('approving_invoice_report_detail_approval_date')}
            </ListViewLabel>
            <ListViewBody key='right' className={cx('listViewBody')}>
              {data?.approved_at}
            </ListViewBody>
          </Top>
          <Top>
            <ListAmount
              totalValue={data?.total_value}
              consumptionTax={data?.total_excise_value}
              withholdingTax={data?.total_withholding_income_tax_value}
              foreignCurrency={data?.foreign_currency_amount}
              totalTransactionDetailsValue={
                data?.total_transaction_details_value
              }
            />
          </Top>
          <Bottom>
            <TaxAnalyze data={data?.tax_rate_items} />
          </Bottom>
        </ListView>
      </div>
    </SectionHeading>
  );
});

BasicInfoSection.displayName = 'BasicInfoSection';
